import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import Navigation from "./components/Navigation";
import Home from "./pages/home";
import Login from "./pages/Login";
import Classes from "./pages/Classes";
import Portfolio from "./pages/Portfolio";
import ClassDetail from "./pages/ClassDetail";
import Contact from "./pages/Contact";
import About from "./pages/about";
import Partners from "./pages/Partners";
import SchoolProgram from "./pages/SchoolProgram";
import CommunityProgram from "./pages/CommunityProgram";
import { AuthProvider } from "./contexts/AuthContext";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/classes/:id" element={<ClassDetail />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/school-program" element={<SchoolProgram />} />
            <Route path="/community-program" element={<CommunityProgram />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
